document.addEventListener("DOMContentLoaded", () => {

    let globalSupportForm = document.getElementById('Form_GlobalSupportContactForm');

    if (globalSupportForm !== null) {
        console.log('Global support form loaded recaptcha');
        globalSupportForm.addEventListener('submit', formSubmitFunction);
    }

    function formSubmitFunction(e) {
        console.log('Global support form loaded submitted');
        e.preventDefault();
        grecaptcha.ready(function() {
            grecaptcha.execute('6LdrSeUqAAAAAKbwhMhIxxT8hpdletAVIwpRnmA4', {action: 'submit'}).then(function(token) {
                console.log('Global support form loaded token');
                document.getElementById('Form_GlobalSupportContactForm_RecaptchaToken').value = token;
                globalSupportForm.submit();
            });
        });
    }
});
